import styles from './EventPeriod.module.scss';

import EventAllDayToggle from 'Screens/Dashboard/Events/EventHandler/inputs/EventPeriod/EventAllDayToggle/EventAllDayToggle';
import EventDateTimePicker from 'Screens/Dashboard/Events/EventHandler/inputs/EventPeriod/EventDateTimePicker/EventDateTimePicker';

const EventPeriod = () => (
    <div className={styles.container}>
        <EventAllDayToggle />
        <EventDateTimePicker />
    </div>
);

export default EventPeriod;
